module.exports = __webpack_public_path__ + "assets/img/0a363972427ad36f6df073a5a1849b08.svg";